<template>
    <div v-if="ad" class="advertisement-placement" :style="containerStyle">
        <a :href="ad.url" @click.prevent="openLink(ad.url)">
            <img :src="imageURL(ad.image)" :alt="ad.name" :style="imageStyle" />
        </a>
    </div>
</template>

<script>
import { imageURL } from "@/mixins/imageURL";

export default {
    name: "advertisement-placement",
    mixins: [imageURL],
    props: {
        placement: {
            type: String,
            required: true,
        },
    },
    computed: {
        ad() {
            return this.$store.state.advertisements[this.placement] || null;
        },
        containerStyle() {
            if (!this.ad) {
                return {};
            }

            return {
                width: `${this.ad.width}px`,
                height: `${this.ad.height}px`,
                maxWidth: "100%",
            };
        },
        imageStyle() {
            return {
                width: "100%",
                height: "100%",
                objectFit: "contain",
                maxWidth: "100%",
                maxHeight: "100%",
            };
        },
    },
    methods: {
        openLink(url) {
            if (this.oWebViewInterface) {
                this.oWebViewInterface.emit("openExternalTab", url);
            } else {
                window.open(url, "_blank");
            }
        },
    },
    data() {
        return {
            oWebViewInterface: window.nsWebViewInterface,
        };
    },
};
</script>

<style lang="scss" scoped>
.advertisement-placement {
    display: block;

    a {
        display: block;
        width: 100%;
        height: 100%;
    }

    img {
        display: block;
    }
}
</style>
